import {useEffect} from 'react'

import {addGlobalNclicksHandler, updateGssc} from '@financial/common-logs'

import {isMobile} from '@web/helpers/userAgent'

/** APP 초기화 hook */
export const useCommonInit = (gSsc?: string) => {
    useEffect(() => {
        addGlobalNclicksHandler()
        updateGssc((gSsc ?? isMobile) ? 'Mpay.etcs' : 'pay.etcs')
    }, [gSsc])
}
